import React, { useContext } from 'react'
import { GeneralContext } from '../context/'
import { Route, Redirect } from "react-router-dom"
import { reactLocalStorage } from "reactjs-localstorage"
import Loading from '../components/Loading'

const AppRoute = ({
	component: Component,
	layout: Layout,
	isAuthProtected,
	...rest
}) => {
    const generalContext = useContext(GeneralContext)
	const {
		loading,
    } = generalContext

    return (
        <Route
            {...rest}
            render={(props) => {
                if (isAuthProtected && !reactLocalStorage.get("token")) {
                    return (
                        <Redirect
                            to={{
                                pathname: "/login",
                                state: { from: props.location }
                            }}
                        />
                    )
                }

                return (
                    <Layout>
                        <Component {...props} />
                        {loading && <Loading />}
                    </Layout>
                )
            }}
        />
    )
}

export default AppRoute
